import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../../helper/url_helper";
import { post, put, get } from "../../../helper/api_helper";
import { showToast } from "../../../helper/common";
import { authSlice } from "../auth/slice";
import { getValuesSocketData } from "../../../helper/secretManager";

let abortController;
export const startJackpot = createAsyncThunk(
  "startJackpot",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      if (abortController) {
        abortController.abort(); // Abort previous request if any
      }
      abortController = new AbortController(); // Create a new controller
      const response = await post(URL.JACKPOT_START, data, {
        signal: abortController.signal,
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }

      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      if (
        error.name === "AbortError" ||
        error?.message === "canceled" ||
        error === "canceled"
      ) {
        callBack && callBack({ message: "canceled" });
        return Thunk.rejectWithValue("Request cancelled");
      } else {
        showToast(error?.message || "Something went wrong!", "error");
        callBack && callBack(error);
        return Thunk.rejectWithValue(error);
      }
    }
  },
);

export const completeJackpot = createAsyncThunk(
  "completeJackpot",
  async ({ data, callBack }, Thunk) => {
    try {
      if (abortController) {
        abortController.abort(); // Abort previous request if any
      }
      abortController = new AbortController(); // Create a new controller
      const { signature, nonce } = await getValuesSocketData();
      const response = await put(URL.JACKPOT_COMPLETE + data?._id, data, {
        signal: abortController.signal,
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response);
      }
      if (response?.status_code === 406) {
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response);
      }
      if (response?.status === "failure") {
        callBack && callBack(response || true, null);
        // showToast(response?.message, "error");
        return Thunk.rejectWithValue(response);
      }
      callBack && callBack(null, response);
      Thunk.dispatch(
        authSlice.actions.setUserDetails({ user: response?.data }),
      );
      // showToast(response?.message, "success");
      return response;
    } catch (error) {
      if (
        error.name === "AbortError" ||
        error?.message === "canceled" ||
        error === "canceled"
      ) {
        callBack && callBack({ message: "canceled" });
        return Thunk.rejectWithValue("Request cancelled");
      } else {
        showToast(error?.message || "Something went wrong!", "error");
        callBack && callBack(error);
        return Thunk.rejectWithValue(error);
      }
    }
  },
);

export const jackpotHistory = createAsyncThunk(
  "jackpotHistory",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.JACKPOT_HISTORY_LIST, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      response.filter = data;
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const jackpotDetails = createAsyncThunk(
  "jackpotDetails",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await get(URL.JACKPOT_DETAILS + data?._id, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response);
      }
      if (response?.status_code === 406) {
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response);
      }
      if (response?.status === "failure") {
        callBack && callBack(response || true, null);
        return Thunk.rejectWithValue(response);
      }
      callBack && callBack(null, response);
      // Thunk.dispatch(authSlice.actions.setUserDetails({ user: response?.data }))
      // showToast(response?.message, "success");
      return response;
    } catch (error) {
      if (error?.message === "canceled" || error === "canceled") {
        callBack && callBack({ message: "canceled" });
        return Thunk.rejectWithValue("Request cancelled");
      } else {
        showToast(error?.message || "Something went wrong!", "error");
        callBack && callBack(error);
        return Thunk.rejectWithValue(error);
      }
    }
  },
);

export const jackpotAmount = createAsyncThunk(
  "jackpotAmount",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await get(URL.JACKPOT_AMOUNT_DATA, { signature, nonce });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response);
      }
      if (response?.status_code === 406) {
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response);
      }
      if (response?.status === "failure") {
        callBack && callBack(response || true, null);
        return Thunk.rejectWithValue(response);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      if (error?.message === "canceled" || error === "canceled") {
        callBack && callBack({ message: "canceled" });
        return Thunk.rejectWithValue("Request cancelled");
      } else {
        showToast(error?.message || "Something went wrong!", "error");
        callBack && callBack(error);
        return Thunk.rejectWithValue(error);
      }
    }
  },
);
